import Vue2TouchEvents from 'vue2-touch-events';
import Vue from '../../node_modules/vue';

Vue.use(Vue2TouchEvents);
